/* src/app/order/components/additional-questions/outsourced-process/outsourced-process.style.scss */
.outsourced-processes-selector {
  margin-bottom: 18px;
}
.outsourced-processes-selector h5 {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  margin-bottom: 10px;
  margin-top: 0;
}
.outsourced-processes-selector .outsourced-processes-checkboxes {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
nb-checkbox {
  margin-right: 5px;
}
@media screen and (max-width: 767px) {
  .outsourced-processes-selector .outsourced-processes-checkboxes {
    flex-wrap: wrap;
  }
}
/*# sourceMappingURL=outsourced-process.style.css.map */
